function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Shape");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Telas-Incendio-Web",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Emiss\\xE3o-Full-Page",
  transform: "translate(-331.000000, -1086.000000)",
  fill: "#FF6414",
  fillRule: "nonzero"
}, React.createElement("g", {
  id: "Group-8",
  transform: "translate(289.000000, 1050.200000)"
}, React.createElement("g", {
  id: "Group-8-Copy"
}, React.createElement("g", {
  id: "Group-22"
}, React.createElement("path", {
  d: "M45.5,39.6 C45.5,37.6116 47.0668333,36 49,36 C50.9331667,36 52.5,37.6116 52.5,39.6 C52.5,41.5884 50.9331667,43.2 49,43.2 C47.0668333,43.2 45.5,41.5884 45.5,39.6 Z M53.6678333,44.4 L53.0220833,44.4 L49.3925833,51.9798 L50.75,45 L49,43.2 L47.25,45 L48.6074167,51.9798 L44.9779167,44.4 L44.3321667,44.4 C42,44.4 42,46.0122 42,48 L42,54 L56,54 L56,48 C56,46.0122 56,44.4 53.6678333,44.4 Z",
  id: "Shape"
}))))));

var SvgUserBeneficiary = function SvgUserBeneficiary(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "14px",
    height: "19px",
    viewBox: "0 0 14 19",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgUserBeneficiary, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/user_beneficiary.48f5fd7c.svg";
export { ForwardRef as ReactComponent };